import { Logo } from '@/shared/components/Logo'
import { Button } from '@workspace/ui/components/Button'
import { DialogContent, DialogOverlay, DialogTrigger } from '@workspace/ui/components/Dialog'
import { MenuIcon } from 'lucide-react'
import { useRouterState } from '@tanstack/react-router'
import React from 'react'
import { SidebarMenu } from '@/shared/layouts/AdminLayout/SidebarMenu'

export function HamburgerMenu() {
    const [isOpen, setIsOpen] = React.useState(false)
    const router = useRouterState()
    const pathname = router.location.pathname

    React.useEffect(() => {
        setIsOpen(false)
    }, [pathname])

    return (
        <DialogTrigger isOpen={isOpen} onOpenChange={setIsOpen}>
            <Button variant="ghost" size="icon" className="size-10 [&>svg]:size-6">
                <MenuIcon />
            </Button>
            <DialogOverlay className="justify-start">
                <DialogContent
                    className="p-0 h-[100dvh] w-[300px] rounded-r-lg rounded-l-none left-0 top-0 bottom-0 translate-x-0 translate-y-0 data-[entering]:slide-in-from-left data-[exiting]:slide-out-to-left"
                    closeButton={false}
                >
                    <div className="flex flex-col h-full">
                        <div className="px-6 py-4 border-b">
                            <Logo />
                        </div>
                        <div className="flex-1 overflow-y-auto py-4">
                            <SidebarMenu />
                        </div>
                    </div>
                </DialogContent>
            </DialogOverlay>
        </DialogTrigger>
    )
}
